import LogosV2 from './LogosV2'
export default LogosV2
